// src/app/interfaces/interface-bakend/patologias/patologias.ts
export const PATOLOGIAS_CONFIG: string[] = [
    'Discapacidad', 
    'Oncologia', 
    'PMI (Plan Materno Infantil)'
  ];